<template>
    <div class="pagina">
    
        <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
    
            <div class="carousel-inner">
    
                <div v-for="(slide, index) in slide_fotos" :class="{ 'active': index === 0 }" :key="index" class="carousel-item text-center">
                    <img class="d-block img-fluid" :src="`https://espais.com.py${slide.imagen.data.url}`" alt="Primer slide imagen Espais">
                    <div class="overlay o-4"></div>
                </div>
    
    
    
            </div>
            <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                      </a>
            <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                      </a>
        </div>
        <div>
            <div class="container my-5 pb-5">
                <h1 class="verde-espais text-center">{{somos.titulo}}</h1>
                <div class="somos">
                    <div v-html="somos.contenido">
                    </div>
                    <p class="font-weight-bold  verde-espais">{{somos.firma}}</p>
                </div>
            </div>
        </div>
    
    
    </div>
</template>

<script>
export default {
    data() {
        return {
            somos: {},
            slide_fotos: []
        }
    },
    methods: {
        loadLogs() {
            this.$http.get(`https://espais.com.py/admin/api/1.1/tables/fotos_inicio/rows/`)
                .then(function(data) {
                    this.slide_fotos = data.body.data;
                })
        },
        loadDescripcion() {
            this.$http.get(`https://espais.com.py/admin/api/1.1/tables/somos_espais/rows/1`)
                .then(function(data) {
                    this.somos = data.body.data;
                })
        },
    },
    mounted() {
        this.$nextTick(function() {
            this.loadLogs();
            this.loadDescripcion();
        })
    }

}
</script>

<style>
.imagen-slide-inicio {}

.pagina {
    padding-top: 0px;
}

@media (max-width: 992px) {
    .pagina {
        padding-top: 59px !important;
    }
}

.bg-trasparent {}

.fondo {
    /* height:  calc(100vh - 64px); */
    height: 100vh;
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.init-page {
    background-color: white;
    z-index: 1;
    grid-column: 1/2;
    grid-row: 1/4;
}

.arrowLeft,
.arrowRight {
    height: 70px;
    width: 70px;
    position: absolute;
    top: 50%;
    font-size: 40px;
    cursor: pointer;
    color: black;
    opacity: 0.4;
    transition: all 0.7s;
}

.arrowLeft {
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
}

.arrowLeft:hover {
    opacity: 1;
}

.arrowRight {
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
}

.arrowRight:hover {
    opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Inicio.vue